import { render, staticRenderFns } from "./SummaryStat.vue?vue&type=template&id=183d6168&scoped=true&"
import script from "./SummaryStat.vue?vue&type=script&lang=js&"
export * from "./SummaryStat.vue?vue&type=script&lang=js&"
import style0 from "./SummaryStat.vue?vue&type=style&index=0&id=183d6168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d6168",
  null
  
)

export default component.exports